<div
  class="flex flex-col flex-wrap h-full print:h-auto print:overflow-visible w-full"
>
  <div
    class="flex items-center w-full px-3 py-2 bg-white shadow-sm z-5 gap-3"
    [ngClass]="toolbarClass"
  >
    @if (showBackButton) {
      <p-button
        size="large"
        variant="text"
        icon="pi pi-arrow-right"
        (onClick)="goBack()"
      >
      </p-button>
    }
    <ng-container *ngTemplateOutlet="toolbarTemplate || null"></ng-container>
  </div>
  <div
    class="flex-1 h-0 w-full px-6 overflow-y-auto print:h-auto print:overflow-visible"
    [ngClass]="contentClass"
    (scroll)="onContentScroll($event)"
  >
    <div class="mt-4!">
      <ng-container *ngTemplateOutlet="contentTemplate || null"></ng-container>
    </div>
  </div>
</div>
